const ROLE = {
  Admin_Non_Student: 'admin-non-student',
  Manager: 'manager',
  Admin: 'admin',
  Manager_Student: 'ms',
  Student: 'member',
};

export { ROLE };
